import { takeLatest, putResolve, select } from 'redux-saga/effects';
import some from 'lodash/some';
import filter from 'lodash/filter';
import find from 'lodash/find';
import { updateChoices, setAvailableChoices } from '../actions';
import safeSaga from './safeSaga';
import { skuDataSelector } from '../selectors/skuDataSelectors';
import { choiceSelectionsSelector } from '../selectors/selections';
import { orderedDependentOptionsSelector, configuratorChoices } from '../selectors/configurator';
import { pricingNodeSelector } from '../selectors/pricing/index';

/* the goal of this saga is to consolidate down the skuData to available choices per option.
  final output should be { optionId: [{availableChoice}, {availableChoice}]}
  this choices can then get picked up by the templates and rendered.  This may be overkill and
  simplified, but needs extensive testing.
*/

function* setChoices() {
  const selections = yield select(choiceSelectionsSelector);
  const orderedOptionIds = yield select(orderedDependentOptionsSelector('SuperSku'));
  const skuData = yield select(skuDataSelector);
  const configChoices = yield select(configuratorChoices);
  const { skuPrices } = yield select(pricingNodeSelector);

  const dependentChoicesByOption = {};
  orderedOptionIds.forEach((optionId, arrIndex) => {
    const nextOption = arrIndex + 1;
    if (nextOption !== orderedOptionIds.length) {
      const currentOptionSelection = find(selections, (selection) => selection.optionId === optionId);
      const currentOptionSkus = filter(skuData, ({ sku, optionChoices }) => {
        const skuIsAvailable = some(skuPrices, (sk) => sk.sku === sku && sk.priceSquareFoot > 0);
        const skuHasMatchingOptionsAndChoice =
          some(optionChoices, (ch) => ch.optionId === optionId && ch.choiceId === currentOptionSelection.choiceId);
        return skuIsAvailable && skuHasMatchingOptionsAndChoice;
      });
      const foundOptions = new Set();
      currentOptionSkus.forEach((pos) => {
        const { optionChoices } = pos;
        optionChoices.forEach((oc) => {
          if (oc.optionId === orderedOptionIds[nextOption]) {
            foundOptions.add(oc.choiceId);
          }
        });
      });
      const foundOptionChoices = [];
      foundOptions.forEach((choiceId) => foundOptionChoices.push(configChoices[choiceId]));
      dependentChoicesByOption[orderedOptionIds[nextOption]] = foundOptionChoices;
    }
  });
  yield putResolve(updateChoices(dependentChoicesByOption));

}

export function* setAvailableChoicesSaga() {
  yield takeLatest(setAvailableChoices.toString(), safeSaga(setChoices));
}
